import React from "react";
import "./App.scss";
import { Route } from "react-router-dom";
import { AnimatedSwitch } from "react-router-transition";
import PlaceholderPage from "./pages/PlaceholderPage";
import { MeetTheExperts } from "./pages/experts/MeetTheExperts";
import { ModalProvider } from "./components/modal/Modal";
import { FactSheetPage } from "./pages/facts/FactSheetPage";
import { HomePage } from "./pages/home/HomePage";
import { MediaResources } from "./pages/media/MediaResources";
import { usePageTracking } from "./util/use-page-tracking";
import { TeaserProvider, TeaserStateContext } from "./util/app-state";
import { HomePage2022 } from "./pages/home/HomePage2022";
import VrHomePage from "./pages/vr/VrPage";

function App() {
  usePageTracking();

  const teaserState = React.useContext(TeaserStateContext);

  let HomePageComponent = HomePage;

  if(teaserState.launch === "hard") {
    HomePageComponent = HomePage2022;
  }

  return (
    <ModalProvider>
      <TeaserProvider>
      <AnimatedSwitch
        atEnter={{ opacity: 0 }}
        atLeave={{ opacity: 0 }}
        atActive={{ opacity: 1 }}
        className="switch-wrapper"
      >
        <Route exact path="/"><HomePageComponent /></Route>
        <Route exact path="/experts"><MeetTheExperts /></Route>
        <Route exact path="/facts"><FactSheetPage /></Route>
        <Route exact path="/media/:section?" render={() => <MediaResources key={Math.random()}/>}></Route>
        <Route exact path="/vr"><VrHomePage /></Route>
        <Route exact path="/placeholder"><PlaceholderPage /></Route>
      </AnimatedSwitch>
      </TeaserProvider>
    </ModalProvider>
  );
}

export default App;
